export default "/_next/static/sounds/vanna-answeryourphone-6b081e3359dc13ba1f31a79ff729ff54.mp3";